(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-qty-wrapper]').forEach(function (wrapper) {
      var input = wrapper.querySelector('[data-qty-input]');
      var form = wrapper.closest('form');

      wrapper.querySelector('[data-qty-minus]').addEventListener('click', function () {
        var val = parseInt(input.value || 1);
        input.value = Math.max(0, val - 1);
        if (form) form.submit();
      });

      wrapper.querySelector('[data-qty-plus]').addEventListener('click', function () {
        input.value = parseInt(input.value || 1) + 1;
        if (form) form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Sort: update ?sort_by= without losing other params
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Price range: update filter params without losing sort or other active filters
  document.querySelectorAll('[data-price-filter]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const url = new URL(window.location.href);
      const minInput = form.querySelector('[data-price-min]');
      const maxInput = form.querySelector('[data-price-max]');
      if (minInput.value !== '') {
        url.searchParams.set(minInput.name, Math.round(parseFloat(minInput.value) * 100));
      } else {
        url.searchParams.delete(minInput.name);
      }
      if (maxInput.value !== '') {
        url.searchParams.set(maxInput.name, Math.round(parseFloat(maxInput.value) * 100));
      } else {
        url.searchParams.delete(maxInput.name);
      }
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Mobile sidebar toggle
  const sidebarToggle = document.querySelector('[data-sidebar-toggle]');
  const sidebar = document.querySelector('[data-sidebar]');
  if (sidebarToggle && sidebar) {
    sidebarToggle.addEventListener('click', function () {
      const isOpen = sidebar.classList.toggle('is-open');
      sidebarToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-global-nav]');
  if (header) {
    const toggle = document.querySelector('[data-menu-toggle]');
    const nav = header.querySelector('[data-menu]');
    const dropdownItems = header.querySelectorAll('.menu-item--has-dropdown');
    const megaColsWithChildren = header.querySelectorAll('.mega-menu__col--has-children');

    // Mobile menu toggle
    if (toggle && nav) {
      toggle.addEventListener('click', function() {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !isOpen);
        nav.classList.toggle('is-open', !isOpen);
        document.body.style.overflow = isOpen ? '' : 'hidden';
      });
    }

    // Mobile L1 dropdown / mega toggle
    dropdownItems.forEach(function(item) {
      const link = item.querySelector(':scope > a');
      if (link) {
        link.addEventListener('click', function(e) {
          if (window.innerWidth <= 768) {
            e.preventDefault();
            item.classList.toggle('is-open');
          }
        });
      }
    });

    // Mobile L2 mega-col toggle (cols that have L3 children)
    megaColsWithChildren.forEach(function(col) {
      const heading = col.querySelector('.mega-menu__col-heading');
      if (heading) {
        heading.addEventListener('click', function(e) {
          if (window.innerWidth <= 768) {
            e.preventDefault();
            col.classList.toggle('is-open');
          }
        });
      }
    });

    // Close menu on resize to desktop
    window.addEventListener('resize', function() {
      if (window.innerWidth > 768 && nav.classList.contains('is-open')) {
        toggle.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  // Hours widget
  (function() {
    var widget = document.querySelector('[data-hours-widget]');
    if (!widget) return;
    var dataEl = widget.querySelector('[data-hours-today]');
    var dot = widget.querySelector('[data-hours-dot]');
    var labelEl = widget.querySelector('[data-hours-label]');
    var toggleBtn = widget.querySelector('[data-hours-toggle]');
    var panel = widget.querySelector('[data-hours-panel]');
    if (!dataEl || !dot || !labelEl || !toggleBtn || !panel) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch(e) { return; }

    var strOpen = widget.getAttribute('data-str-open') || 'Open';
    var strClosed = widget.getAttribute('data-str-closed') || 'Closed';

    function timeToMins(str) {
      if (!str) return -1;
      var p = str.split(':');
      return parseInt(p[0], 10) * 60 + parseInt(p[1], 10);
    }

    function updateBadge() {
      var now = new Date();
      var cur = now.getHours() * 60 + now.getMinutes();
      if (data.closed) {
        dot.className = 'hours-widget__dot hours-widget__dot--closed';
        labelEl.textContent = strClosed;
      } else {
        var open = timeToMins(data.open);
        var close = timeToMins(data.close);
        if (open >= 0 && close >= 0 && cur >= open && cur < close) {
          dot.className = 'hours-widget__dot hours-widget__dot--open';
          labelEl.textContent = strOpen;
        } else {
          dot.className = 'hours-widget__dot hours-widget__dot--closed';
          labelEl.textContent = strClosed;
        }
      }
    }

    updateBadge();

    toggleBtn.addEventListener('click', function() {
      var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
    });

    document.addEventListener('click', function(e) {
      if (!widget.contains(e.target)) {
        toggleBtn.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var productDataEl = document.getElementById('product-data');
    if (!productDataEl) return;

    var variants = JSON.parse(productDataEl.textContent).variants;
    var variantIdInput = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var comparePriceEl = document.querySelector('[data-compare-price]');
    var addToCartBtn = document.querySelector('[data-add-to-cart]');
    var addToCartText = document.querySelector('[data-add-to-cart-text]');
    var mainImageWrap = document.querySelector('[data-main-image]');
    var thumbs = document.querySelectorAll('[data-thumb-index]');

    // --- Thumbnail gallery ---
    function activateThumb(index) {
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('product__thumb--active', parseInt(thumb.dataset.thumbIndex) === index);
      });
      var active = Array.from(thumbs).find(function (t) {
        return parseInt(t.dataset.thumbIndex) === index;
      });
      if (active && mainImageWrap) {
        var img = mainImageWrap.querySelector('img');
        if (img) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = active.dataset.imageSrc;
        }
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateThumb(parseInt(this.dataset.thumbIndex));
      });
    });

    // --- Variant selection ---
    function getSelectedOptions() {
      return Array.from(document.querySelectorAll('[data-option-group]')).map(function (group) {
        var active = group.querySelector('.product__option-btn--active');
        return active ? active.dataset.optionValue : null;
      });
    }

    function findVariant(selectedOptions) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceEl) priceEl.textContent = variant.priceFormatted;

      if (comparePriceEl) {
        if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
          comparePriceEl.textContent = variant.compareAtPriceFormatted;
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.style.display = 'none';
        }
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
      }
      if (addToCartText) {
        addToCartText.textContent = variant.available
          ? addToCartBtn.dataset.textAvailable
          : addToCartBtn.dataset.textUnavailable;
      }

      if (variant.featuredImagePosition !== null && thumbs.length > 0) {
        activateThumb(variant.featuredImagePosition - 1);
      }
    }

    document.querySelectorAll('.product__option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = this.closest('[data-option-group]');
        group.querySelectorAll('.product__option-btn').forEach(function (b) {
          b.classList.remove('product__option-btn--active');
        });
        this.classList.add('product__option-btn--active');

        var optionIndex = this.dataset.optionIndex;
        var labelEl = document.querySelector('[data-selected-value="' + optionIndex + '"]');
        if (labelEl) labelEl.textContent = this.dataset.optionValue;

        var variant = findVariant(getSelectedOptions());
        if (variant) updateForVariant(variant);
      });
    });

    // --- Quantity stepper ---
    var qtyWrapper = document.querySelector('[data-qty-wrapper]');
    if (qtyWrapper) {
      var qtyInput = qtyWrapper.querySelector('[data-qty-input]');
      qtyWrapper.querySelector('[data-qty-minus]').addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1) - 1);
      });
      qtyWrapper.querySelector('[data-qty-plus]').addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value || 1) + 1;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
